import Vue from 'vue';
import Vuex from 'vuex';

import addresses from './modules/addresses';
import auth from './modules/auth';
import billboard from './modules/billboard';
import cart from './modules/cart';
import checkout from './modules/checkout';
import dispatchPortal from './modules/dispatchPortal';
import orders from './modules/orders';
import pendingOrders from './modules/pendingOrders';
import products from './modules/products';
import profile from './modules/profile';
import utils from './modules/utils';
import navbar from './modules/navbar';
import search from './modules/search';
import contact from './modules/contact';
import driverApplication from './modules/driverApplication'

Vue.use(Vuex);
const u = navigator.userAgent
const store = new Vuex.Store({
  state: {
    uni: null,
    env: null,
    appSystemInfo: null,
    openAppInfo: {
      UniversalLink: 'https://shopafm.com/',
      urlSchemes: 'shopafm.com://'
    },
    isAndroidWeb: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
    isIosWeb: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    navGoId: 0,
    showProductsType1: null,
    showProductsType2: null,
    showProductsType3: null,
    showList: null
  },
  mutations: {
    ['CHANGE_UNI'](state, data) {
      state.uni = data
    },
    ['CHANGE_ENV'](state, data) {
      state.env = data
    },
    ['CHANGE_APP_SYSTEM_INFO'](state, data) {
      state.appSystemInfo = data
    },
    ['CHANGE_NAV_GO_ID'](state, data) {
      state.navGoId = data
    },
    ['CHANGE_SHOW_PRODUCTS_TYPE1'](state, data) {
      state.showProductsType1 = data
    },
    ['CHANGE_SHOW_PRODUCTS_TYPE2'](state, data) {
      state.showProductsType2 = data
    },
    ['CHANGE_SHOW_PRODUCTS_TYPE3'](state, data) {
      state.showProductsType3 = data
    },
    ['CHANGE_SHOWLIST'](state, data) {
      state.showList = data
    },
  },
  actions: {
    changeUni(context, data) {
      context.commit('CHANGE_UNI', data);
    },
    changeEnv(context, data) {
      context.commit('CHANGE_ENV', data);
    },
    changeAppSystemInfo(context, data) {
      context.commit('CHANGE_APP_SYSTEM_INFO', data);
    },
    changeNavGoId(context, data) {
      context.commit('CHANGE_NAV_GO_ID', data);
    },
    changeShowProductsType1(context, data) {
      context.commit('CHANGE_SHOW_PRODUCTS_TYPE1', data);
    },
    changeShowProductsType2(context, data) {
      context.commit('CHANGE_SHOW_PRODUCTS_TYPE2', data);
    },
    changeShowProductsType3(context, data) {
      context.commit('CHANGE_SHOW_PRODUCTS_TYPE3', data);
    },
    changeShowList(context, data) {
      context.commit('CHANGE_SHOWLIST', data);
    },
  },
  getters: {
    isApp: state => {
      const {env, appSystemInfo} = state
      return !!((env && env.plus) || (appSystemInfo && appSystemInfo.platform));
    },
    isIosApp: state => {
      const {appSystemInfo} = state
      return appSystemInfo && appSystemInfo.platform === 'ios'
    }
  },
  modules: {
    addresses,
    auth,
    billboard,
    cart,
    checkout,
    dispatchPortal,
    orders,
    pendingOrders,
    products,
    profile,
    utils,
    navbar,
    search,
    contact,
    driverApplication,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js